<template>
    <div class="screen-saver">
        <el-row :gutter="20" type="flex">
            <el-col :span="6" class="logo-item create-logo">
                <div class="upload" @click="addScreenSaverVisible=true">
                    <p><i class="el-icon-upload"></i></p>
                    <p>{{$t('shang_chuan_dai_ji_ping_bao')}}</p>
                </div>
            </el-col>
            <el-col :span="6" v-for="(item, index) in pictures" :key="index">
                <div class="logo-item">
                    <el-image
                            class="image"
                            :src="item.urls[0]"
                            :preview-src-list="item.urls">
                    </el-image>
                    <p class="logo-item-text-info">
                        <span class="edit-screen-saver" @click="editScreenSaver(item)">{{$t('bian_ji_ping_bao')}}</span>
                    </p>
                </div>
            </el-col>
        </el-row>
        <c-dialog :visible.sync="addScreenSaverVisible" :width="'51.5rem'" :height="'40rem'" :title="$t('shang_chuan_dai_ji_ping_bao')">
            <el-button slot="title" size="mini" type="primary" @click="createScreenSaver">{{$t('bao_cun')}}</el-button>
            <multi-upload :tip="$t('xian_zhi_fen_bian_lv_can_kao_ji_xing_fen_bian_lv_shou_ce')" :accept="'image/*'" ref="multiSaver"
                          :uploadSuccess="uploadSuccess"
                          class="screen-saver-upload"></multi-upload>
        </c-dialog>

    </div>


</template>

<script>
    import MultiUpload from '@/components/MultiUpload'
    import CDialog from '@/components/Dialog'
    import {screenSaverCreate, screenSaverList} from '@/api/delivery/device/screenSaver'

    export default {
        name: '',
        components: {
            MultiUpload,
            CDialog,
        },
        mounted: function () {
            this.loadScreenSaver()
        },
        data: function () {
            return {
                addScreenSaverVisible: false,
                pictureViewerVisible: false,
                pictures: [],
                url: [],
            }
        },
        methods: {
            closeViewer() {
                this.pictureViewerVisible = false
            },
            createScreenSaver() {
                this.$refs.multiSaver.handleUpload()
            },
            loadScreenSaver() {
                screenSaverList().then(res => {
                    this.pictures = res.data || []
                })
            },
            editScreenSaver(item){
                this.$router.push({name: 'delivery.devices.screenManager.screenSaver.detail', params: item})
            },
            uploadSuccess(urls) {
                if (urls.length === 0) {
                    this.$message.warning(this.$t('qing_xian_xuan_qu_ping_bao_tu_pian'))
                } else {
                    screenSaverCreate({
                        urls: urls
                    }).then(res => {
                        this.pictures.push({uuid: res.data, urls: urls})
                        this.addScreenSaverVisible = false
                    })
                }
            },
            showPicture(item){
                this.url = item.urls
                this.pictureViewerVisible = true
            },
        },
    }
</script>

<style lang="scss">
    .screen-saver {
        margin-bottom: $padding;
        flex-flow: row wrap;
        align-content: flex-start;
        .logo-item {
            background-color: $bg_sec_color;
            border: .2rem;
            margin-bottom: $padding;
            .image {
                width: 100%;
                height: 10rem;
                cursor: pointer;
            }
            .logo-item-text-info {
                padding: $padding-5;
                font-size: .6rem;
                color: $f_sec_color;
                text-align: center;
                span {
                    cursor: pointer;
                }
                span:hover {
                    color: $f_color;
                }
                .look-devices, .edit-screen-saver {
                    margin-left: $padding-5;
                    display: inline-block;
                }
                .look-screen-saver {
                    span {
                        font-size: .4rem;
                    }
                }
            }
        }

        .create-logo {
            background-color: transparent;
            min-height: 11.6rem;
            .upload {
                background-color: $bg_sec_color;
                width: 100%;
                height: 100%;
                display: flex;
                /*实现垂直居中*/
                align-items: center;
                /*实现水平居中*/
                justify-content: center;

                text-align: justify;
                cursor: pointer;
            }
        }

        .screen-saver-upload {
            height: 8rem;
            .el-upload-list--picture-card .el-upload-list__item {
                width: 256px;
                height: 150px;
            }
        }
    }
</style>
